<template>
  <div id="certificateReminderModal">
    <v-dialog :value="true" persistent :max-width="570">
      <v-card>
        <v-card-title class="headline warning white--text">
          {{ $t('certificateReminderDialog.title') }}
        </v-card-title>
        <v-card-text class="pt-4 text--primary text-subtitle-1">
          {{ $t('certificateReminderDialog.text') }}
        </v-card-text>
        <v-card-text class="text-subtitle-1">
          <a
            :href="$t('certificateReminderDialog.link.url')"
            target="_blank"
            rel="noopener"
          >
            {{ $t('certificateReminderDialog.link.text') }}
          </a>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog">
            {{ $t('certificatesAlert.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  methods: {
    closeDialog() {
      this.$emit('closeCertificateReminderDialog')
    },
  },
}
</script>
